module.exports = __webpack_public_path__ + "static/media/040.7db73162.jpg";